// ==============================|| OVERRIDES - ICON BUTTON ||============================== //

export default function IconButton(theme) {
	return {
		MuiIconButton: {
			defaultProps: {
				disableTouchRipple: true,
			},
		}
	}
}
